<template>
  <div id="app">
    <div class="wrapper">
      <Header :style="'padding-left: 1%; padding-right: 1%; margin-left: 0 !important'" />
      <!--<Sidebar />-->
      <router-view :style="'margin-left: 0 !important'" />
      <Footer style="bottom: 0; margin-left: 0 !important;" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
// import Sidebar from '@/components/organisms/OrSidebar'
import Footer from '@/components/organisms/OrFooter'

export default {
  name: 'App',
  components: {
    Header,
    Footer
    // Sidebar
  },
  data () {
    return {
      user_token: localStorage.getItem('fs_token'),
      user_id: localStorage.getItem('fs_user_id')
    }
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user || this.user_token) return true
      return false
      /* if (localStorage.getItem('token') === '1') {
        return true
      }
      if (this.$store.state.Auth.user) {
        return true
      }
      return false */
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
  },
  created () {
    // if (this.user_id !== '9') this.$router.push({ name: 'M0002LandingPage' })
    /*
    this.$store.dispatch('Auth/initUser')
      .then(user => {
        this.user_token = localStorage.getItem('fs_token')
        if (!user) {
          localStorage.removeItem('fs_token')
          if (this.$route.name !== 'Login') this.$router.push('/Login')
        } else {
          if (this.$route.name === 'Login') {
            this.$router.push({name: 'Top'})
          }
        }
      })
      */
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poiret+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap');

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: black;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

label:not(.form-check-label):not(.custom-file-label) {
  font-weight: normal !important;
  line-height: normal !important;
}

.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
span.badge {
  line-height: normal !important;
}
</style>
